import React, { useState } from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { BasicButton, TextButton } from '../../widgets/buttons';
import { FormControl } from '../../widgets/formControl';
import { NotificationBanner } from '../../widgets/notificationBanner';
import { Button1 } from './myAccountComponents';

export const OrangeLabel = styled.label`
    color: #f46200;
`;

export const BlackLabelEl = styled.label`
    color: black;
    text-decoration: none;
`;

export const SalesChannelsLinkList = styled.div`
    display: inline-block;
    gap: 10px;
`;

export const SalesChannelsLinkListContainer = styled.div`
    margin-left: 4px;
    display: flex;
    gap: 6px;
`;

export const SalesChannelLabel = styled.div`
    width: 100%;
    svg {
        width: 17px;
        height: 17px;
        margin-right: 4px;
    }
    display: flex;
`;

export const Interlinea = styled.span`
    line-height: 2;
`;

export const CancelSubscriptionLabel = styled.div`
    display: flex;
    label {
        align-self: center;
    }
`;

export const BadgeStatusLabel = styled.span<{ $active?: boolean }>`
    display: inline-flex;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    width: fit-content;
    background: ${(p) => (p.$active ? '#d6f3e2' : '#f0f0f0')};
    color: ${(p) => (p.$active ? '#065f46' : '#6b7280')};
`;

export const BorderedRectangle = styled.div`
    border: 1px solid #dbe2e6 !important;
    border-radius: 8px !important;
    padding: 18px 24px;
    height: 340px;
    width: 256px;
    display: flex;
    flex-direction: column;
    gap: 6px;

    @media (max-width: 1400px) {
        width: 100%;
    }
`;

export const ServiceCreditsAddonWrapper = styled(BorderedRectangle)<{ $noCredits?: boolean }>`
	position: relative;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	grid-column: span 2;
	width: auto;

    @media (max-width: 1400px) {
        grid-column: span 2;
        height: auto;
        min-height: 340px;
    }

    ${(p) =>
        p.$noCredits &&
        `
		animation: credits-card-blink 0.8s ease-in-out infinite;
		@keyframes credits-card-blink {
			0%, 100% {
				box-shadow: none;
				border-color: #dbe2e6;
			}
			50% {
				box-shadow: 0 3px 16px rgba(211, 47, 47, 0.4), 0 8px 36px rgba(211, 47, 47, 0.3);
				border-color: #ffaaaa !important;
			}
		}
	`}
`;

export const PeriodTooltip = styled.div`
    display: inline-flex;
    width: min-content;
    div {
        width: max-content;
    }
    label {
        width: max-content;
    }
`;

export const BorderedRectangleForViewsReport = styled(BorderedRectangle)<{ isFromCurrentBilling: boolean }>`
    border: 1px solid #dbe2e6 !important;
    border-radius: 8px !important;
    padding: 10px;
    height: ${(props) => (props.isFromCurrentBilling ? '285px' : '250px')};
    width: 260px;
`;

export const SubscriptionGrid = styled.div`
    display: grid;
    grid-template-rows: auto 1fr auto auto;
    gap: 6px;
    flex: 1;
    width: 100%;
`;

export const SquaresContainer = styled.div`
    display: grid;
    justify-content: left;
    grid-template-columns: repeat(auto-fill, minmax(242px, 1fr));
    gap: 30px;
    grid-row-gap: 20px;
    padding-top: 20px;
    padding-bottom: 40px;

    @media (max-width: 1400px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

export const ReportContainer = styled.div`
    display: grid;
    grid-template-rows: auto auto auto;
    gap: 20px;
    padding-top: 20px;
`;

export const BasicButtonActivate = styled(BasicButton)<{ isActive?: boolean }>`
    width: inherit;

    ${(props) =>
        props.isActive
            ? `
      background: none;
      border: none;
      color: ${props.theme.app.component.textButton.destructive.default.color};
      font-weight: 600;

      &[disabled] {
        opacity: 0.5;
        color: ${props.theme.app.component.textButton.destructive.default.color};
      }

      &:hover:not([disabled]) {
        background: none !important;
        color: ${props.theme.app.component.textButton.destructive.hover.color};
        text-decoration: underline !important;
      }

      &:active:not([disabled]) {
        background: none;
        color: ${props.theme.app.component.textButton.destructive.active.color};
      }
    `
            : `
      background-color: ${props.theme.app.component.button.primary.default.backgroundColor};
      border: ${props.theme.app.component.button.primary.border};
      color: ${props.theme.app.component.button.primary.default.textColor};

      &[disabled] {
        opacity: ${props.theme.app.component.button.primary.disabled.opacity};
        background-color: ${props.theme.app.component.button.primary.disabled.backgroundColor};
        color: ${props.theme.app.component.button.primary.disabled.textColor};
        border: ${props.theme.app.component.button.primary.disabled.border};
      }

      &:hover:not([disabled]) {
        background-color: ${props.theme.app.component.button.primary.hover.backgroundColor};
        color: ${props.theme.app.component.button.primary.hover.textColor};
      }

      &:active:not([disabled]) {
        background-color: ${props.theme.app.component.button.primary.active.backgroundColor};
        color: ${props.theme.app.component.button.primary.active.textColor};
      }
    `}
`;

export const ActivateRemoveContainer = styled.div`
    width: 100%;
    border-top: 1px solid #dbe2e6;
    padding-top: 10px;
    margin-top: auto;
    height: 34px; // 24 svg + 10 padding top, make height consistent with spinner to avoid layout shift when button changes from text to spinner

    svg {
        width: 24px;
        height: 24px;
    }
`;

export const AddOnHeader = styled.div`
    padding: 5px;
    display: grid;
    grid-template-rows: 55% 35%;
    /* margin-top:	auto; */
`;

export const AddPriceSection = styled(AddOnHeader)`
    margin-top: auto;
`;

export const NoSubscriptionWarningBlock = styled.div`
    padding: 20px;
    display: grid;
    gap: 20px;
    justify-content: center;
`;

export const TextButtonMoreAddOns = styled(TextButton)`
    cursor: pointer;
    padding-top: 30px !important;
`;

export const AddOnDescription = styled(AddOnHeader)`
    display: block;
    height: 136px;
    font-size: 14px;
    overflow-y: auto;
    color: #445a64;

    a {
        display: inline-block;
    }
`;

export const AddOnButtonContainer = styled.div`
    justify-content: center;
`;

const BannerContainer = styled(FormControl)`
    margin-bottom: 24px !important;
`;

interface SubscriptionProps {
    subscription: {
        ecommerceName: string;
        subscription: any;
    };
}

const BannerWarningSubscription: React.FC<SubscriptionProps> = ({ subscription }) => {
    const [isWarningVisible, setWarningVisible] = useState(false);
    const [isButtonVisible, setButtonVisible] = useState(true);

    const handleOpenWarning = () => {
        setWarningVisible(true);
        setButtonVisible(false);
    };

    const handleCloseWarning = () => {
        setWarningVisible(false);
        setButtonVisible(true);
    };

    return (
        <div>
            {isButtonVisible && (
                <Button1>
                    <TextButton type='destructive' onClick={handleOpenWarning}>
                        {subscription?.subscription?.inTrial ? T._('Cancel trial', 'Admin') : T._('Cancel subscription', 'Admin')}
                    </TextButton>
                </Button1>
            )}

            {isWarningVisible && (
                <BannerContainer>
                    <NotificationBanner
                        type='WARNING'
                        content={
                            <span>
                                {T._(
                                    `If you want to cancel your subscription you need to remove Zakeke from the apps in your ${subscription.ecommerceName.toLowerCase()} admin panel.`,
                                    'Admin'
                                )}
                            </span>
                        }
                        showCloseButton={true}
                        onClose={handleCloseWarning}
                    />
                </BannerContainer>
            )}
        </div>
    );
};

export default BannerWarningSubscription;
